import { Injectable } from '@angular/core';
import {AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument} from 'angularfire2/firestore';
import {Chargingpoints} from '../pages/layout/list-chargers/list-chargers.component';
import { map, filter, catchError, mergeMap } from 'rxjs/operators';
import 'rxjs/add/operator/map';

@Injectable({
  providedIn: 'root'
})
export class ChargingpointsService {

  constructor(private afs: AngularFirestore) { }

  getChargingpoints(){
    return this.afs.collection<Chargingpoints>('ChargingPoints').snapshotChanges().map(actions => {
      return actions.map(action => {
        const data = action.payload.doc.data() as Chargingpoints;
        const id = action.payload.doc.id;
        return { id, ...data };
      });
    });;
  } 
}

